
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'

export default {
name: 'ApplyTryPage',
components: {
XInput,
XButton,
Group,
Cell,
Msg
},
data () {
return {
mobile: '',
contact: '',
companyName: ''
}
},
methods: {
submitApply: function () {
let that = this
let url = '/wxapi/user/submitApplyTry'
this.$axios.post(url, {}, {params: {contact: that.contact, mobile: that.mobile, companyName: that.companyName}}).then(function (res) {
if (res.meta.success) {
that.$Msgbox.alert('提交成功！')
} else {
console.error(res.meta.message)
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}).catch(function (error) {
console.info(error)
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/user/ApplyTryPage.vue